<template>
  <section class="section-two bg-light mt-5 mb-2">

    <div class="container-fluid">
      <div class="row m-3 justify-content-center">

        <div class="col-lg-10" v-if="!loading">

          <div class="row">

            <div class="col-md-12">
              <div class="alert alert-danger" role="alert" v-if="msgErrorSchedule">
                {{ msgErrorSchedule }}
              </div>
            </div>

            <div class="col-md-6" v-if="paymentMethod?.is_credit_card">
              <SavedCreditCardList 
                v-if="showSavedCards && savedCreditCards.length > 0"
                :saved-cards="savedCreditCards"
                :selected-card-id="selectedCreditCardId"
                @card-selected="onCardSelected"
                @show-new-card="showNewCardForm"
              />

              <div v-if="!showSavedCards || savedCreditCards.length === 0">
                <CreditCardMP @onSubmit="onSubmitFormCreditCard"
                              v-if="place.card_administrator_code == 'MP'">
                  <template #saveCardOptions v-if="place?.supports_tokenization">
                    <div class="row mt-3" v-if="!selectedCreditCardId">
                      <div class="col-md-12">
                        <div class="form-check mb-2">
                          <input class="form-check-input" type="checkbox" id="saveCardExam" v-model="saveCard">
                          <label class="form-check-label" for="saveCardExam">
                            Salvar cartão para próximos pagamentos
                          </label>
                        </div>
                        <div v-if="saveCard" class="mb-3">
                          <label class="form-label" for="cardNicknameExam">Apelido do cartão (opcional):</label>
                          <input type="text" class="form-control" id="cardNicknameExam" 
                                 v-model="cardNickname" 
                                 placeholder="Ex: Cartão principal"
                                 maxlength="50">
                        </div>
                      </div>
                    </div>
                  </template>
                </CreditCardMP>

                <CreditCardGN @onSubmit="onSubmitFormCreditCard"
                              v-else-if="place.card_administrator_code == 'GN'">
                  <template #saveCardOptions v-if="place?.supports_tokenization">
                    <div class="row mt-3" v-if="!selectedCreditCardId">
                      <div class="col-md-12">
                        <div class="form-check mb-2">
                          <input class="form-check-input" type="checkbox" id="saveCardExam" v-model="saveCard">
                          <label class="form-check-label" for="saveCardExam">
                            Salvar cartão para próximos pagamentos
                          </label>
                        </div>
                        <div v-if="saveCard" class="mb-3">
                          <label class="form-label" for="cardNicknameExam">Apelido do cartão (opcional):</label>
                          <input type="text" class="form-control" id="cardNicknameExam" 
                                 v-model="cardNickname" 
                                 placeholder="Ex: Cartão principal"
                                 maxlength="50">
                        </div>
                      </div>
                    </div>
                  </template>
                </CreditCardGN>

                <CreditCardEF @onSubmit="onSubmitFormCreditCard"
                              v-else-if="place.card_administrator_code == 'EF'">
                  <template #saveCardOptions v-if="place?.supports_tokenization">
                    <div class="row mt-3" v-if="!selectedCreditCardId">
                      <div class="col-md-12">
                        <div class="form-check mb-2">
                          <input class="form-check-input" type="checkbox" id="saveCardExam" v-model="saveCard">
                          <label class="form-check-label" for="saveCardExam">
                            Salvar cartão para próximos pagamentos
                          </label>
                        </div>
                        <div v-if="saveCard" class="mb-3">
                          <label class="form-label" for="cardNicknameExam">Apelido do cartão (opcional):</label>
                          <input type="text" class="form-control" id="cardNicknameExam" 
                                 v-model="cardNickname" 
                                 placeholder="Ex: Cartão principal"
                                 maxlength="50">
                        </div>
                      </div>
                    </div>
                  </template>
                </CreditCardEF>

                <CreditCardAS @onSubmit="onSubmitFormCreditCard"
                              v-else-if="place.card_administrator_code == 'AS'">
                  <template #saveCardOptions v-if="place?.supports_tokenization">
                    <div class="row mt-3" v-if="!selectedCreditCardId">
                      <div class="col-md-12">
                        <div class="form-check mb-2">
                          <input class="form-check-input" type="checkbox" id="saveCardExam" v-model="saveCard">
                          <label class="form-check-label" for="saveCardExam">
                            Salvar cartão para próximos pagamentos
                          </label>
                        </div>
                        <div v-if="saveCard" class="mb-3">
                          <label class="form-label" for="cardNicknameExam">Apelido do cartão (opcional):</label>
                          <input type="text" class="form-control" id="cardNicknameExam" 
                                 v-model="cardNickname" 
                                 placeholder="Ex: Cartão principal"
                                 maxlength="50">
                        </div>
                      </div>
                    </div>
                  </template>
                </CreditCardAS>

                <div v-else class="text-center">
                  <h3>Falha ao carregar dados, tente novamente</h3>
                  <a class="btn btn-primary" :href="$route.fullPath">
                    Tentar novamente
                  </a>
                </div>
              </div>
            </div>

            <div :class="paymentMethod?.is_credit_card ? 'col-md-6' : 'col-md-10 offset-md-1'" class="mb-3">
              <div class="rounded shadow-lg p-4 sticky-bar">
                <div class="d-flex mb-0 justify-content-between">
                  <h5>Confirme os dados</h5>
                </div>
                <div class="table-responsive">
                  <table class="table table-center table-padding mb-0">
                    <tbody>
                    <tr>
                      <td colspan="12" class="pb-0">
                        <p class="h6">Local: </p>
                        <p class="fw-bold pb-0">{{ place.place_name }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="12" class="pb-0">
                        <p class="h6">Endereço: </p>
                        <p class="fw-bold pb-0">
                          {{ place.place_full_address }}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="12" class="pb-0">
                        <p class="h6">Tipo de agendamento: </p>
                        <p class="fw-bold pb-0">
                          Exames
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="12" class="pb-0">
                        <p class="h6">Atendimento: </p>
                        <p class="fw-bold pb-0">
                          Por ordem de chegada
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="12" class="pb-0">
                        <p class="h6">Horário: </p>
                        <p class="fw-bold pb-0">
                          {{ place.availability.dsc_availability }}
                        </p>
                      </td>
                    </tr>
                    <tr class="bg-light" v-if="place.total_value">
                      <td colspan="12" class="pb-0">
                        <p class="h6">Valor: </p>
                        <p class="text-primary pb-0 h5 fw-bold">R$ {{ Number(place.total_value).toFixed(2)  }}</p>
                      </td>
                    </tr>
                    </tbody>
                  </table>

                  <div class="mt-4 pt-2" v-if="!paymentMethod?.is_credit_card">
                    <div class="d-grid">
                      <button class="btn btn-primary" type="button" @click="scheduleExam">
                        Agendar exames
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal" id="ExamModalAddress" tabindex="-1" data-bs-keyboard="false" data-bs-backdrop="static"
           aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <form @submit.prevent="scheduleExam">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Confirme o seu endereço</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label for="address_cep" class="form-label required">
                        CEP <i class="text-danger">*</i>
                      </label>
                      <input type="text" class="form-control" id="address_cep"
                             @change="getZipCode($event.target.value)" required
                             v-model="userAddress.user_addr_zipcode">
                    </div>
                  </div>
                  <div class="col-md-8">
                    <div class="mb-3">
                      <label for="address" class="form-label required">
                        Endereço <i class="text-danger">*</i>
                      </label>
                      <input type="text" class="form-control" id="address" required
                             v-model="userAddress.user_address">
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label for="address_nro" class="form-label required">
                        Número <i class="text-danger">*</i>
                      </label>
                      <input type="text" class="form-control" id="address_nro" required
                             v-model="userAddress.user_addr_numer">
                    </div>
                  </div>
                  <div class="col-md-8">
                    <div class="mb-3">
                      <label for="address_neighbourhood" class="form-label required">
                        Bairro <i class="text-danger">*</i>
                      </label>
                      <input type="text" class="form-control" id="address_neighbourhood" required
                             v-model="userAddress.user_neighborhood">
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="mb-3">
                      <label for="address_complement" class="form-label">
                        Complemento
                      </label>
                      <input type="text" class="form-control" id="address_complement"
                             v-model="userAddress.user_addr_compl">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label for="address_stage" class="form-label">
                        Estado <i class="text-danger">*</i>
                      </label>
                      <InputSelect :required="true"
                                   id="address_stage"
                                   label="state_name"
                                   @change="getCitiesFromState($event)"
                                   value="id_state"
                                   :options="states"
                                   v-model="userAddress.id_state"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label for="address_city" class="form-label">
                        Cidade <i class="text-danger">*</i>
                      </label>
                      <InputSelect id="address_city" :required="true"
                                   label="city_name"
                                   value="id_city"
                                   :options="citiesFromState"
                                   v-model="userAddress.id_city"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <div class="col-md-12">
                  <div class="d-grid">
                    <button type="submit" class="btn btn-primary">
                      Agendar consulta
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import CreditCardMP from '../gateways/CreditCardMP.vue'
import CreditCardGN from "../gateways/CreditCardGN.vue";
import CreditCardEF from "../gateways/CreditCardEF.vue";
import CreditCardAS from "../gateways/CreditCardAS.vue";
import SavedCreditCardList from "../components/SavedCreditCardList.vue";
import date from "@/helpers/date";
import {mask} from 'vue-the-mask';
import Alert from "../../../helpers/alert";
import Swal from "sweetalert2";
import NoResult from "../NoResult.vue";
import InputSelect from "../../components/InputSelect.vue";
import http from "../../../helpers/http";

export default {
  name: 'Payment',
  components: {
    CreditCardEF,
    InputSelect,
    CreditCardGN,
    CreditCardMP,
    CreditCardAS,
    NoResult,
  },
  directives: {
    mask,
  },
  data() {
    return {
      loading: false,
      msgErrorSchedule: '',
      creditCard: null,
      selectedCreditCardId: null,
      saveCard: false,
      cardNickname: '',
      showSavedCards: true,
      states: null,
      citiesFromState: null,
      userAddress: {
        user_address: null,
        user_addr_zipcode: null,
        user_addr_numer: null,
        user_addr_compl: null,
        user_neighborhood: null,
        id_city: null,
        id_state: null,
      },
    };
  },
  async mounted() {
    await this.getStates();

    this.userAddress = {
      user_address: this.userAuth.user_address,
      user_addr_zipcode: this.userAuth.user_addr_zipcode,
      user_addr_numer: this.userAuth.user_addr_numer,
      user_addr_compl: this.userAuth.user_addr_compl,
      user_neighborhood: this.userAuth.user_neighborhood,
      id_city: this.userAuth.id_city,
      id_state: this.userAuth.id_state,
    };

    if (this.userAuth.id_state) {
      await this.getCitiesFromState(this.userAuth.id_state);
    }

    this.loading = true;
    setTimeout(() => this.loading = false, 700);

    if (this.place == null) {
      Swal.fire({
        icon: 'warning',
        title: 'Falha ao carregar local',
        showConfirmButton: true,
        confirmButtonText: 'Tente novamente',
      }).then((result) => {
        if (result.isConfirmed) {
          location.reload();
        }
      });
    }

    if (this.paymentMethod?.is_credit_card && this.userAuth?.id_user && this.place?.card_administrator_code) {
      this.$store.dispatch('toSchedule/getSavedCreditCards', this.place.card_administrator_code).then(() => {
        if (this.savedCreditCards.length === 0) {
          this.showSavedCards = false;
        }
      });
    }
  },
  computed: {
    userAuth() {
      return this.$store.state.auth.user;
    },
    paymentMethod() {
      return this.$store.state.toSchedule.schedule.paymentMethod;
    },
    place() {
      return this.$store.state.toSchedule.schedule.place;
    },
    savedCreditCards() {
      return this.$store.state.toSchedule.savedCreditCards;
    },
  },
  methods: {
    date: date,
    getStates() {
      return http.get(`/states`).then((response) => {
        this.states = response.data;
      });
    },
    getCitiesFromState(stateId) {
      return http.get(`/states/${stateId}/cities`).then((response) => {
        this.citiesFromState = response.data;

        return response;
      });
    },
    getZipCode(zipCode) {
      http.get(`/zipcode/${zipCode}`).then((response) => {
        let data = response.data;
        this.userAddress.user_address = data.address;
        this.userAddress.user_neighborhood = data.neighborhood;
        let state = data.state;
        this.userAddress.id_state = state?.id_state;
        this.getCitiesFromState(state?.id_state);
        this.userAddress.id_city = data.city?.id_city;
      });
    },
    onSubmitFormCreditCard(creditCard) {
      this.creditCard = creditCard;

      let modal = bootstrap.Modal.getOrCreateInstance(document.querySelector('#ExamModalAddress'));
      modal.toggle();
    },
    scheduleExam() {
      this.msgErrorSchedule = '';
      if (this.paymentMethod.is_credit_card && !this.creditCard && !this.selectedCreditCardId) {
        Alert.error('Falha ao processar os dados do cartão de crédito - Verifique sua conexão e tente novamente.');

        return;
      }

      if (this.paymentMethod.is_credit_card) {
        let modal = bootstrap.Modal.getOrCreateInstance(document.querySelector('#ExamModalAddress'));
        modal.toggle();
      }

      Swal.fire({
        title: 'Agendando',
        text: 'Por favor, aguarde',
        allowOutsideClick: false,
      });
      Swal.showLoading();

      this.$store.dispatch('toSchedule/scheduleExam', {
        creditCard: this.creditCard,
        creditCardTokenId: this.selectedCreditCardId,
        saveCard: this.saveCard,
        cardNickname: this.cardNickname,
        userAddress: this.userAddress
      }).then(() => {
        this.creditCard = null;
        this.selectedCreditCardId = null;
        this.saveCard = false;
        this.cardNickname = '';
        if (this.paymentMethod?.is_pix) {
          this.$router.push('/pix');
        } else {
          this.$router.push('/scheduled');
        }

        Swal.close();
      }).catch(e => {
        Swal.close();
        const response = e.response;
        let errorMessage = response?.data?.message || 'Falha ao agendar consulta';
        
        if (response?.status === 422 && response.data?.errors) {
          const errorMessages = Object.values(response.data.errors).flat();
          errorMessage = errorMessages.length > 0 ? errorMessages.join('<br>') : errorMessage;
        } else if (typeof response?.data === 'string') {
          errorMessage = response.data;
        }
        
        this.msgErrorSchedule = errorMessage;
        Swal.fire({
          icon: 'error',
          title: 'Falha ao agendar consulta',
          html: errorMessage,
        });
      });
    },
  }
}
</script>

<style scoped>

</style>
